import React from "react"
import { Row } from "react-bootstrap"
import { FormattedMessage } from "react-intl"
import { StockDocumentMovementTimelineProps } from "../../../common/types/timeline"
import { INVENTORY_STOCK_DIRECTION } from "../../../utils/inventory"

const StockDocumentMovementComponent = (props: StockDocumentMovementTimelineProps) => {
    const getProductTitle = (rowId: string) => {
        const row = props.stockDocument.attributes.table.attributes.items.find(row => row.id === rowId)
        return row?.attributes.itemObject.attributes.title ?? ""
    }

    const direction = props.stockDocument.attributes.definition.attributes.direction === INVENTORY_STOCK_DIRECTION.OUT ?
        <FormattedMessage
            id="quote.events.stock_document_movement.direction_out"
            defaultMessage="sent"
        /> :
        <FormattedMessage
            id="quote.events.stock_document_movement.direction_in"
            defaultMessage="received"
        />

    return (
        <div 
            data-document-event="stock-document-movement"
            data-document-direction={props.stockDocument.attributes.definition.attributes.direction.toLowerCase()} >
            <FormattedMessage
                id="quote.events.stock_document_movement.text"
                defaultMessage="{seller} {direction} the following items on {document} {identifier}"
                values={{
                    seller: props.object.attributes.seller.attributes.name,
                    direction: direction,
                    document: props.stockDocument.attributes.definition.attributes.name,
                    identifier: props.stockDocument.attributes.identifier,
                }}
            />
            <div className={"pb-1"}></div>
            {props.object.attributes.movements?.map((movement, i) => {
                return (
                    <Row key={i} className={"m-0"}>
                        {movement.measure}&nbsp;X&nbsp;{getProductTitle(movement.rowId)}
                    </Row>
                )
            }
            )}
        </div>
    )
}

export default StockDocumentMovementComponent


// WEBPACK FOOTER //
// ./src/quote/analytics/events/stock-document-movement.component.tsx